import React from "react";
import "./HomeWelcomeView.css";
import backgroundImage from "../../assets/landing_background.png";
import waveHighlight from '../../assets/svg/wave-highlight.svg';

const HomeWelcomeView = () => {
    return (
        <div className="landing-container">
            <main className="landing-content">
                <h1 className="headline">
                    Mobile applications for ease and
                    <span class="highlight">
                        <img src={waveHighlight} alt="Wave Highlight" class="wave" />
                        <span class="highlighted-word">emotions, to make </span> boring routine things brighter
                    </span>
                </h1>
                <p className="description">
                    We are also clients of our services, so we understand well what we tell about.
                </p>
                <button className="cta-button" disabled>Find something for yourself</button>
            </main>

            <div className="background-image">
                <img src={backgroundImage} alt="Background" />
            </div>
        </div>
    );
};

export default HomeWelcomeView;